import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Dialog, FlatButton } from 'material-ui';
import TextArea from '../../textarea';
import { validEmail } from '../../tc-ui/csv-upload/helperFunctions';

const RequestSigDialog = props => {
  const {
    cancel,
    open,
    subject,
    message,
    invitees,
    rateDocId,
    signatures = [],
    updateProps,
    sending,
    realActorEmail,
    requestSigsFunc,
    crId,
  } = props;
  const send = () => requestSigsFunc({
    rateDocIds: [rateDocId],
    emails: invitees,
    subject,
    message,
    sentBy: realActorEmail,
    requestSigsChecked: true,
    crId,
  });
  return (
    <Dialog
      style={{ zIndex: 2102 }}
      open={open}
      onRequestClose={cancel}
      autoScrollBodyContent
      title="Request Signatures"
      actions={[
        <FlatButton
          key="cancel"
          label="cancel"
          primary
          onClick={cancel}
        />,
        <FlatButton
          key="send"
          label={signatures.length ? 'resend' : 'send'}
          secondary
          disabled={sending || !invitees.length}
          onClick={send}
        />,
      ]}
    >
      {
        Boolean(signatures && signatures.length) && (
          <div style={{ marginBottom: '32px' }}>
            <label>Requests sent:</label>
            {
              signatures.map((sig, i) => (
                <div key={i} className="flex-tc-sb">
                  <div>{sig.invitee}</div>
                  <small>{moment(sig.inviteSentAt).format('DD MMM YYYY')}</small>
                  <small>{sig.inviteSentBy}</small>
                </div>
              ))
            }
          </div>
        )
      }
      <label>Please separate invitees with a semicolon;</label>
      <br/>
      <TextArea
        value={invitees.join(';')}
        onChange={e => updateProps({ invitees: e.target.value.split(';') })}
        rows={2}
        error={invitees.some(str => str && !validEmail(str)) ? 'Please enter valid email addresses' : ''}
      />
      <label>Please enter a subject here:</label>
      <br/>
      <TextArea
        value={subject || ''}
        onChange={e => updateProps({ subject: e.target.value })}
        rows={1}
      />
      <label>Optional message:</label>
      <TextArea
        value={message || ''}
        onChange={e => updateProps({ message: e.target.value })}
        rows={4}
      />
      <label>Sent By: {realActorEmail}</label>
    </Dialog>
  );
};

RequestSigDialog.propTypes = {
  cancel: PropTypes.func,
  updateProps: PropTypes.func,
  open: PropTypes.bool,
  subject: PropTypes.string,
  message: PropTypes.string,
  invitees: PropTypes.array,
  rateDocId: PropTypes.string,
  signatures: PropTypes.array,
  realActorEmail: PropTypes.string,
  sending: PropTypes.bool,
  requestSigsFunc: PropTypes.func,
};

export default connect(({ dummyAcct, user }) => ({
  ...dummyAcct.requestSigs,
  realActorEmail: user.get('realActorEmail'),
}), {
  cancel: () => ({ type: '{dummy-account}CANCEL_REQUEST_SIGNATURE' }),
  updateProps: payload => ({ type: '{dummy-account}UPDATE_PROPS', payload }),
  requestSigsFunc: payload => ({ type: '{dummy-account} REQUEST_SIGNATURE', payload }),
})(RequestSigDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/request-sigs-dialog.jsx